export default __webpack_public_path__ + "static/media/tickCircleIcon.0e0049b3.svg";